import { render, staticRenderFns } from "./viewnewcustomers.vue?vue&type=template&id=3e5cef94&scoped=true&"
import script from "./viewnewcustomers.vue?vue&type=script&lang=js&"
export * from "./viewnewcustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5cef94",
  null
  
)

export default component.exports